import React from 'react';
import CustomActiveShapePieChart from "../../charts/CustomActiveShapePieChart";
import {ResponsiveContainer, XAxis, YAxis} from "recharts";
import Widget from "../../../prefabricated/Widget";
import {useSelector} from "react-redux";

const TileAdminDashPaidCustomerPieChart = ({props})=>{

    const {users, loadingUsers, loadingUsersError, } = useSelector(({users}) => users);
    const {okr, loadingAdminOKR, loadingAdminOKRError}= useSelector(({admin})=>admin);


    // const okr = testOKR;
    // const loadingAdminOKR = false;
    // const loadingAdminOKRError = false;

    const engagementDetails = okr && okr.engagement_details;
    const nonPaidEngagementDetails = engagementDetails && engagementDetails.non_paid;
    const nonPaidCustomersArray = nonPaidEngagementDetails && Object.keys(nonPaidEngagementDetails);
    const paidEngagementDetails = engagementDetails && engagementDetails.paid;
    const paidCustomersArray = paidEngagementDetails && Object.keys(paidEngagementDetails);

    const numPaidCustomers = paidCustomersArray && Array.isArray(paidCustomersArray) && paidCustomersArray.length;
    const numNonPaidCustomers = nonPaidCustomersArray && Array.isArray(nonPaidCustomersArray) && nonPaidCustomersArray.length;

    // console.log("nonPaidCutomersArray", nonPaidCustomersArray, numNonPaidCustomers,"paidCustomersArray", paidCustomersArray, numPaidCustomers);

    const showPieWith = () => {
        if (okr && !loadingAdminOKR && !loadingAdminOKRError) {

            try {

                const arrayData = engagementDetails
                    ?[{name: "Paid", value: numPaidCustomers}, {name: "Non-Paid", value: numNonPaidCustomers}]
                    : [];


                return <div
                    className={"animated fadeIn animation-duration-7"}
                    style={{ marginTop: -40, marginBottom: -15 }}
                ><CustomActiveShapePieChart
                    data = {arrayData}
                    loading = {loadingAdminOKR || !arrayData}
                /></div>


            } catch(e) {
                console.warn(e);
                return null
            }
        } else {
            return null
        }
    }



    const valueFunction = (stateData) => {
        return numNonPaidCustomers + numPaidCustomers;
    }

    return(
        // <DataTile
        //     subTitle="Customer Type"
        //     tipText={`Visual Representation of Number of Paid vs Non-Paying Customers.`}
        //     icon={<div
        //         className={"animated fadeIn animation-duration-7"}
        //         style={{ marginTop: -40, marginBottom: -15 }}
        //     ><CustomActiveShapePieChart
        //         data = {[]}
        //         // riskBy5={-1}
        //         loading
        //     /></div>}
        //     iconFunction = {showPieWith}
        //     iconClasses={" "}
        //     // stateName="users"
        //     // stateElement="okr"
        //     dontFetch
        //     // forceLoadingState = {myEntity && myEntity.settings && myEntity.settings.last_cycle_id && social ? false : true}
        //     valueFunction={<></>}
        // />

    <Widget styleName={`bg-light animated fadeIn animation-duration-5 dataTile`}>
        <div className="row align-self-center" style={{width: "100%"}}>
            <ResponsiveContainer height={200} minWidth={400}>
                {okr && !loadingAdminOKR && !loadingAdminOKRError
                    ? showPieWith()
                    : <div
                        className={"animated fadeIn animation-duration-7"}
                        style={{ marginTop: -40, marginBottom: -15 }}>
                        <CustomActiveShapePieChart
                        data = {[]}
                        // riskBy5={-1}
                        loading
                    />
                </div>}
            </ResponsiveContainer>
        </div>
    </Widget>
    )
}

export default TileAdminDashPaidCustomerPieChart;